import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';
import { useEffect } from 'react';

import { EmptySelect } from '@/components/selectors/emptySelect';
import { useDAL } from '@/contexts/useDAL';

const title = 'Machine type';

export const GcpMachineTypeSelect = ({
  machineType,
  onChange,
  accountId,
  zone,
}: {
  machineType?: string;
  onChange: (machineType?: string, isUserChange?: boolean) => void;
  accountId?: string;
  zone?: string;
}) => {
  if (!accountId || !zone) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerGcpMachineTypeSelect
      machineType={machineType}
      onChange={onChange}
      accountId={accountId}
      zone={zone}
    />
  );
};

const InnerGcpMachineTypeSelect = ({
  machineType,
  onChange,
  accountId,
  zone,
}: {
  machineType?: string;
  onChange: (machineType?: string, isUserChange?: boolean) => void;
  accountId: string;
  zone: string;
}) => {
  const dal = useDAL();
  const { data: body, isLoading } = dal.restore.gcpVm.useListMachineTypes(
    accountId,
    zone
  );

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (machineType && !body?.machineTypes?.includes(machineType)) {
      onChange(undefined);
    }
  }, [body?.machineTypes, isLoading, onChange, machineType]);

  if (!body?.machineTypes?.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        clearOnBlur
        size='small'
        value={machineType || ''}
        onChange={(event, newValue) => onChange(newValue || '')}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              InputLabelProps={{ shrink: true }}
            />
          );
        }}
        options={body.machineTypes}
      />
    </FormControl>
  );
};
